import { moveItemInArray } from '@angular/cdk/drag-drop';
import { Injectable } from '@angular/core';
import { CurrentService, BillOperate } from 'dbweb-core';
import { Observable, of, throwError } from 'rxjs';
import * as uuid from 'uuid';
import {
	AddCategoryParam,
	AddLabelParam,
	EleViewBackFaceService,
	FetchLabelResult,
	ModelElementCategory,
	ModelElementLabel,
	SetCategoryPositionParam,
	SetCategoryPositionResult,
	SetLabelPositionParam,
	SetLabelPositionResult,
	UpdateCategoryParam,
	UpdateLabelParam
} from '../../services/eleview/eleview-backface';
import { Category } from '../../services/eleview/types/category';
import {
	IElementHis,
	ILabel,
	ILabelHisItem,
	ILabelHisKey,
	ILabelKey,
	INode,
	OwnerByEnum,
	ownerElement
} from '../../services/eleview/types/model';
import { map } from 'rxjs/operators';
import { ElementDataRecordView } from './element.service';
import { BackFace } from '../../components/label-manager/service/backface';

function newID() {
	const buf = uuid.v1(null, []);
	const TYPED_ARRAY = new Uint8Array(buf);
	const STRING_CHAR = TYPED_ARRAY.reduce((data, byte) => {
		return data + String.fromCharCode(byte);
	}, '');
	const base64String = btoa(STRING_CHAR);
	return base64String;
}
@Injectable()
export class LabelMockBackfaceService implements BackFace {
	isAdd: boolean;
	recordViewData: ElementDataRecordView;
	constructor(private backface: EleViewBackFaceService, private curr: CurrentService) {}
	addCategory(param: AddCategoryParam): Observable<Category> {
		if (!param.Name) {
			return throwError('åç§°ä¸ºç©º');
		}
		if (this.recordViewData.labelCategories.find(v => v.Name === param.Name)) {
			return throwError('åç§°éå¤');
		}
		const newCate = {
			ID: newID(),
			EleName: param.EleName,
			OwnerBy: param.OwnerBy,
			Owner: ownerElement,
			Name: param.Name
		} as ModelElementCategory;
		if (param.BeforeAtID) {
			this.recordViewData.labelCategories.splice(
				this.recordViewData.labelCategories.findIndex(v => v.ID === param.BeforeAtID),
				0,
				newCate
			);
		} else {
			this.recordViewData.labelCategories.push(newCate);
		}
		this.recordViewData.labelCategories.forEach((v, i) => (v.Position = i + 1));
		const rev = new Category();
		rev.ID = newCate.ID;
		rev.Name = newCate.Name;
		rev.Owner = newCate.Owner;
		rev.OwnerBy = newCate.OwnerBy;
		rev.Position = newCate.Position;
		return of(rev);
	}
	removeCategory(id: string): Observable<boolean> {
		this.recordViewData.labelCategories
			.splice(this.recordViewData.labelCategories.findIndex(v => v.ID === id), 1)
			.forEach((v, i) => (v.Position = i + 1));
		return of(true);
	}
	setCategoryPosition(param: SetCategoryPositionParam): Observable<SetCategoryPositionResult[]> {
		moveItemInArray(
			this.recordViewData.labelCategories,
			this.recordViewData.labelCategories.findIndex(v => v.ID === param.ID),
			param.Position - 1
		);
		this.recordViewData.labelCategories.forEach((v, i) => (v.Position = i + 1));
		return of(this.recordViewData.labelCategories.map(v => ({ ID: v.ID, Position: v.Position })));
	}
	updateCategory(param: UpdateCategoryParam): Observable<boolean> {
		const c = this.recordViewData.labelCategories.find(v => v.ID === param.ID);
		c.Name = param.Name;
		return of(true);
	}
	fetchCategories(param: { EleName: string; OwnerBy: OwnerByEnum; Owner: string }): Observable<Category[]> {
		// æ°å¢ç¶æä¸ï¼ä¸è½å»åæ°æ®ï¼å ä¸ºæå¯è½ä¼åå°å·²å­å¨çè®°å½æ°æ®ï¼é ææ³å¯
		if (this.isAdd) {
			return of([]);
		}
		return this.backface
			.fetchFullCategories({ EleName: param.EleName, OwnerBy: param.OwnerBy, Owner: param.Owner })
			.pipe(
				map(cates => {
					this.recordViewData.labelCategories = cates;
					return this.recordViewData.labelCategories.map(v => {
						let lbls: { ID: string; Name: string }[];
						if (v.Labels) {
							lbls = v.Labels.map(lbl => ({
								ID: lbl.ID,
								Name: lbl.Name
							}));
						}
						return Category.fromInterface({
							ID: v.ID,
							Name: v.Name,
							Owner: v.Owner,
							OwnerBy: v.OwnerBy,
							Position: v.Position,
							Labels: lbls
						});
					});
				})
			);
	}
	// è·åèåé¡¹æææ ç­¾çæ¥å¿
	fetchCategoryLabelHis(param: {
		EleName: string;
		OwnerBy: OwnerByEnum;
		Owner: string[];
	}): Observable<IElementHis[]> {
		if (this.isAdd) {
			return of([]);
		}
		return this.backface.fetchCategoryLabelHis(param);
	}
	// è·åæ ç­¾çæ¥å¿åè¡¨
	fetchLabelHisList(param: ILabelKey): Observable<ILabelHisItem[]> {
		if (this.isAdd) {
			return of([]);
		}
		return this.backface.fetchLabelHisList(param);
	}
	// æ ¹æ®æ¶é´è·ålabelçåå®¹
	fetchLabelHis(
		param: ILabelHisKey
	): Observable<{
		Conts: string;
		PlainText: string;
	}> {
		return this.backface.fetchLabelHis(param);
	}
	addLabel(param: AddLabelParam): Observable<ILabel> {
		const c = this.recordViewData.labelCategories.find(v => v.ID === param.CategoryID);
		c.Labels = c.Labels || [];
		if (c.Labels.find(v => v.Name === param.Name)) {
			return throwError('éå¤çåç§°');
		}
		const lbl = {
			CategoryID: param.CategoryID,
			ID: newID(),
			Name: param.Name,
			LastWriteTime: new Date(),
			LastWriteUser: this.curr.data.UserName,
			Conts: param.Conts,
			PlainText: param.PlainText
		} as ModelElementLabel;
		c.Labels.push(lbl);
		c.Labels.forEach((v, i) => (v.Position = i + 1));
		return of(lbl);
	}
	removeLabel(param: ILabelKey): Observable<boolean> {
		const lbls = this.recordViewData.labelCategories.find(v => v.ID === param.CategoryID).Labels;
		lbls.splice(lbls.findIndex(v => v.ID === param.ID), 1);
		return of(true);
	}
	nodeToString(param: INode): Observable<string> {
		return this.backface.nodeToString(param);
	}
	stringToNode(param: string): Observable<INode> {
		return this.backface.stringToNode(param);
	}
	setLabelPosition(param: SetLabelPositionParam): Observable<SetLabelPositionResult[]> {
		const lbls = this.recordViewData.labelCategories.find(v => v.ID === param.CategoryID).Labels;
		moveItemInArray(lbls, lbls.findIndex(v => v.ID === param.ID), param.Position - 1);
		lbls.forEach((v, i) => (v.Position = i + 1));
		return of(lbls.map(v => ({ ID: v.ID, Position: v.Position })));
	}
	updateLabel(param: UpdateLabelParam): Observable<ILabel> {
		const lbl = this.recordViewData.labelCategories
			.find(v => v.ID === param.CategoryID)
			.Labels.find(v => v.ID === param.ID);
		lbl.Name = param.Name;
		lbl.Conts = param.Conts;
		lbl.PlainText = param.PlainText;
		lbl.LastWriteTime = new Date();
		return of(lbl);
	}
	fetchLabel(param: ILabelKey): Observable<FetchLabelResult> {
		return of(
			this.recordViewData.labelCategories.find(v => v.ID === param.CategoryID).Labels.find(v => v.ID === param.ID)
		);
	}
}
